<svg viewBox="25 25 50 50">
  <circle
    cx="50"
    cy="50"
    r="20"
    [attr.fill]="'none'"
    [attr.stroke-width]="'4'"
    stroke-miterlimit="10"
  />
</svg>
